<script>
export default {
    name: "RadioSelectPopup",
    props: {
        title: String,
        options: Array,
        show: {
            type: Boolean,
            default: false,
        }
    },
    data() {
        return {
            selectedIndex: null,
        }
    },
    methods: {
        selectOption(index) {
            this.selectedIndex = index;
            this.closePopup();
        },
        closePopup() {
            const option = this.selectedIndex !== null ? this.options[this.selectedIndex].value : '';
            this.$emit('close', option);
        },
        closeOutSide(e) {
            if ( !this.$refs['popupElement'].contains(e.target) ) {
                this.closePopup();
            }
        }
    },
    watch: {
        show(newValue, oldValue) {
           if ( newValue !== oldValue ) {
               if ( newValue ) {
                   setTimeout(() => {
                       document.addEventListener("click", this.closeOutSide);
                   })
               }
               else {
                   document.removeEventListener("click", this.closeOutSide);
               }
           }
        }
    }
}
</script>

<template>
<div>
    <MountingPortal append mountTo="#configurator-field-menu" multiple>
        <div v-if="show" class="z-50 fixed left-0 top-0 w-full h-full bg-darkblue-800 bg-opacity-50 flex justify-center items-center">
            <div class="container flex justify-center items-center">
                <div ref="popupElement" class="bg-white rounded-md shadow-12dp border border-solid border-darkblue-400" style="max-width: 335px;">
                    <span class="inline-block w-full text-2 text-2--semibold !text-darkblue-800 py-3 px-4 mb-2.5 border-b border-solid border-darkblue-400">{{ title }}</span>
                    <button @click="selectOption(index)" class="w-full inline-flex justify-between items-center pl-4 pr-5 py-1.5 mb-2.5" v-for="(option, index) in options">
                        <span>{{ option.label }}</span>
                        <span class="relative w-5 h-5 block border border-solid border-dark-400 rounded-full" :class="{'bg-darkblue !border-darkblue': index === selectedIndex }">
                            <span class="block w-2 h-2 bg-white rounded-full absolute left-1/2 top-1/2 transform -translate-x-1/2 -translate-y-1/2"></span>
                        </span>
                    </button>
                </div>
            </div>
        </div>
    </MountingPortal>
</div>
</template>

<style scoped lang="scss">

</style>